import { AppState } from '../AppStateProvider/interfaces';

export const complete = (state: AppState) => {
	console.group("🔍 COMPLETE CHECK");

	console.log("state.preview:", state.preview);
	console.log("state.pairing:", state.pairing);
	console.log("state.brand:", state.brand);
	console.log("state.device:", state.device);
	console.log("state.market:", state.market);
	console.log("localStorage.kvps:", localStorage.getItem("kvps"));

	// Weg 1: Preview-Setup
	const previewComplete =
		state.preview &&
		state.brand !== null &&
		//todo below is deprecated. update when fixing preview
		// state.url !== null &&
		state.device !== null;

	console.log("➤ previewComplete:", previewComplete);

	// Weg 2: Normal-Setup
	const normalComplete =
		state.brand !== null &&
		((state.market !== null && localStorage.getItem('kvps') !== null) ||
			state.market?.urls?.delivery !== null) &&
		state.device !== null &&
		localStorage.getItem('pairing') === 'true';

	const result = previewComplete || normalComplete;

	console.log("✅ FINAL RESULT:", result);
	console.groupEnd();

	return result;
};
